module.exports = __webpack_public_path__ + "img/xingganggy.7652eef2.jpg";